import React from "react"
import { Section, TeamContent } from "@alexanderathoodly/ui-library"
import { BlockFooter } from "../blockfooter"
import { CommonBlockProps } from "../types"
import { getIconPath } from "../../helpers/getIconPath"
import teamdata from "../../data/team-data.json"
import { ExtendedExpertInfo } from "../../settings/team"

export interface TeamSectionProps extends CommonBlockProps {
    template: "team-section"
    members: string[]
}

const TeamSection = ({
    id,
    color,
    icon = "profile",
    label,
    headline,
    members = [],
    footertext,
    buttons,
    ...rest
}: TeamSectionProps): JSX.Element => {
    return (
        <Section
            id={id || undefined}
            className="experts-section"
            shape="shape7"
            backgroundColor={color}
            icon={getIconPath(icon)}
            label={label}
            headline={headline}
            headlineColor="green"
            {...rest}
        >
            <TeamContent
                {...{
                    members: members
                        .filter((member) => teamdata.members.map((m) => m.fullName).includes(member))
                        .map((member) => teamdata.members.find((i) => i.fullName === member) as ExtendedExpertInfo),
                }}
            />
            <BlockFooter footertext={footertext} buttons={buttons} position={headline} />
        </Section>
    )
}

export { TeamSection }
